import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TileGrid.css';

const TileGrid = ({ tiles }) => {
  const navigate = useNavigate();

  const handleTileClick = (tile) => {
    if (tile.path) {
      navigate(tile.path);
    } else if (tile.onClick) {
      tile.onClick();
    }
  };

  return (
    <div className="tile-grid">
      {tiles.map((tile, index) => (
        <div
          key={tile.id}
          className={`tile ${tile.fullWidth ? 'tile-full' : ''} ${tile.accent ? 'tile-accent' : ''}`}
          onClick={() => handleTileClick(tile)}
          style={{ 
            animationDelay: `${index * 0.05}s`,
            '--tile-color': tile.color || 'var(--rf-primary)'
          }}
        >
          <div className="tile-icon-wrapper" style={{ background: tile.iconBg || 'rgba(255,255,255,0.2)' }}>
            {tile.icon}
          </div>
          <div className="tile-content">
            <span className="tile-title">{tile.title}</span>
            {tile.subtitle && <span className="tile-subtitle">{tile.subtitle}</span>}
          </div>
          {tile.badge && (
            <span className="tile-badge">{tile.badge}</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default TileGrid;
